import { View } from './view';
import { Subtotal } from '../config/subtotal';
import { Translations } from '../config/translations';
import { HelpUrls } from '../config/help-urls';
import { DonationFrequencyType } from '../config/donation-frequency-type';

import { ResourceCache } from '../utils/resource-cache';
import { Form } from '../forms/form';
import { ProductForm } from '../forms/product-form';
import { SubscriptionForm } from '../forms/subscription-form';
import { AddonForm } from '../forms/addon-form';
import { AdaptivePricesForm } from '../forms/adaptive-prices-form';
import { AdaptiveSubscriptionPricesForm } from '../forms/adaptive-subscription-prices-form';
import { BehaviorSubject } from 'rxjs';
import { FormTypes } from '../forms/form-types';

export class WidgetView extends View {

    widgetFooterContainer = document.createElement('form');
    cacheService = ResourceCache.getInstance();
    translationsInstance = Translations;

    paymentMethodLabels: { [key: string]: string } = {
        'stripe': Translations.CREDIT_CARD,
        'paypal': Translations.PAYMENT_METHOD_PAYPAL,
        'stripe_google_pay': Translations.STRIPE_GOOGLE_PAY,
        'stripe_apple_pay': Translations.STRIPE_APPLE_PAY,
        'stripe_ach': Translations.STRIPE_ACH,
        'stripe_bacs': Translations.STRIPE_BACS,
        'offline_payment': Translations.OFFLINE_PAYMENT_METHOD
    };

    renderDiscount(discountTypes: any[]) {
        const discountWrapper = document.createElement('div');
        discountTypes.forEach((item) => {
            const discount = document.createElement('span');
            discount.innerHTML = item;
            discountWrapper.appendChild(discount);
        });
    }

    getTotal() {
        const totalChar = document.getElementById('df-final-amount');
        if (totalChar) {
            return parseInt(totalChar.innerText.replace(/^\D+/g, ''), 10);
        }
    }

    renderPaymentTypeRadioButtons(paymentType: string[], hubSpotFormId: string, eventHandler: any) {
        const form = document.createElement('form');
        form.setAttribute('id', 'df-payment-method');
        form.classList.add('hs-form', 'stacked', 'df-payment-method', 'df-f', 'df-f-pay-options');

        const checkboxes = document.createElement('ul');
        checkboxes.className = 'inputs-list multi-container';

        paymentType.forEach((payment) => {
            const checked = payment === paymentType[0] ? 'checked' : '';
            const checkIfTranslationExists = this.getPaymentLabelKey(payment);
            const checkbox = document.createElement('li');
            checkbox.className = 'hs-form-radio';
            checkbox.innerHTML = `
                <label id='${payment}' class='hs-form-radio-display'>
                    <input class='hs-input df-payment-type' type='radio' name='paymentType' value='${payment}' checked='${checked}'>
                    <span class='df-f-label' ${checkIfTranslationExists && ('data-label=' + checkIfTranslationExists)}>${this.paymentMethodLabels[payment]}</span>
                </label>`;

            checkboxes.appendChild(checkbox);
        });

        form.appendChild(this.wrapElementHSStyles(Translations.PAY_WITH, checkboxes));

        const container = this.getDFContainer();
        const hubSpotForm = this.getHubSpotForm(container, hubSpotFormId);
        if (hubSpotForm) {
            container.insertBefore(form, hubSpotForm.nextSibling);
        }
        this.checkActivePaymentType(paymentType[0]);
        this.addCheckboxesEventListener(eventHandler);
    }

    getPaymentLabelKey(payment: string) {
        const translateKey = Object.keys(Translations).find(key => (Translations as any)[key] === this.paymentMethodLabels[payment]);
        return translateKey && translateKey.toLowerCase();
    }

    getHubSpotForm(container: HTMLElement, hubSpotFormId: string) {
        const nodes = container.children;
        for (let i = 0; i < nodes.length; i++) {
            const node = nodes[i];
            const nodeClassName = node.className;
            if (nodeClassName.indexOf('hsForm_' + hubSpotFormId) > -1 || nodeClassName.indexOf('hs-form-iframe') > -1) {
                return node;
            }
        }
        return null;
    }

    addCheckboxesEventListener(eventHendler: any) {
        const elements = document.getElementsByClassName('df-payment-type');
        Array.prototype.forEach.call(elements, (element: HTMLInputElement) => {
            element.onchange = (event) => {
                eventHendler(event);
            };
        });
    }

    checkActivePaymentType(paymentType: string) {
        const elements = document.getElementsByClassName('df-payment-type');
        const button = Array.prototype.find.call(elements, (element: any) => element.value === paymentType);
        button.checked = true;
    }

    renderWidgetFooter(submitCallback: any): void {

        this.widgetFooterContainer.classList.add('hs-form', 'stacked', 'df-f', 'df-f-footer');
        this.widgetFooterContainer.setAttribute('id', 'df-widget-footer');
        this.widgetFooterContainer.innerHTML = `
           <fieldset class='form-columns-1 df-fieldset'>
                <div class='hs_submit'>
                    <div id='df-total-amount-container' class='actions'>
                        <div class='df-total-amount'>
                            <div id='df-subtotals' class='df-subtotals'>

                                <div class='df-subtotal df-subtotal-subscription'>
                                    <div class="df-f-label-container">
                                        <span class='sub-name df-f-label'></span><span class='sub-quantity df-f-label'></span>
                                    </div>
                                    <div class="df-f-value-container">
                                        <span class='base-price df-f-value'></span><span class='sub-frequency df-f-value'></span> <span class='sub-charges df-f-value'></span>
                                    </div>
                                </div>

                                <div class='df-subtotal df-subtotal-quantity'>
                                    <div class="df-f-label-container">
                                        <span class='prod-name df-f-label'></span><span class='quantity-amount df-f-label'></span></div>
                                    <div class="df-f-value-container">
                                        <span class='base-price df-f-value'></span>
                                    </div>
                                </div>

                                <div class='df-subtotal df-subtotal-addons'>
                                    <div id="df-addon-container">
                                    </div>
                                </div>

                                <div class='df-subtotal df-subtotal-discount'>
                                    <div class="df-f-label-container">
                                        <span class='df-f-label'>${Translations.DISCOUNT}</span>
                                    </div>
                                    <div class="df-f-value-container">
                                        <span class='discount df-f-value'></span>
                                    </div>
                                </div>

                                <div class='df-subtotal df-subtotal-tax'>
                                    <div class="df-f-label-container">
                                        <span class='df-f-label' data-label="tax">${Translations.TAX}</span> (<span class='tax-rate df-f-label'></span>%):
                                    </div>
                                    <div class="df-f-value-container">
                                        <span class='amount df-f-value'></span>
                                    </div>
                                </div>


                            </div>
                            <div class='df-final-total'>
                                <div class="df-f-label-container">
                                    <span class='df-final-amount-label df-f-label' data-label="total">${Translations.TOTAL}</span>
                                </div>
                                <div class="df-f-value-container">
                                    <span id='df-final-amount' class='df-final-amount df-f-value'></span><span id='df-subscription-interval' class='df-f-value'></span>
                                </div>
                            </div>
                        </div>
                        <input type='submit' data-label="pay_now" value='${Translations.PAY_NOW}' class='hs-button primary large df-pay-btn df-input' id='df_buybtn' />
                    </div>
                </div>
            </fieldset>
            <div id='df-paypal-form-block'></div>
            <div id='stripe-mobile-pay-form-block'></div>
            <div id='stripe-ach-form-block'></div>
        `;

        const paypalBtn = this.getHtmlElement('#df-pay-pal-button');
        const paypalBlock: any = document.getElementById('paypal-form-block');
        if (paypalBtn) {
            paypalBtn.onclick = submitCallback;
        }

        this.widgetFooterContainer.onsubmit = (event) => {
            event.preventDefault();

            if (!paypalBlock || paypalBlock.style.display === 'none') {
                submitCallback();
            }
        };

        const container = this.getDFContainer();
        if (container) {
            container.appendChild(this.widgetFooterContainer);
            this.renderPayPalButton();
            this.renderCopyright(container);
        }
    }

    showFooterForm() {
        this.widgetFooterContainer.style.display = 'initial';
    }

    hideFooterForm() {
        this.widgetFooterContainer.style.display = 'none';
    }

    showPaymentMethods() {
        const paymentMethodElement = this.getHtmlElement('#df-payment-method');
        if (paymentMethodElement) {
            this.show(paymentMethodElement);
        }
    }

    hidePaymentMethods() {
        const paymentMethodElement = this.getHtmlElement('#df-payment-method');
        if (paymentMethodElement) {
            this.hide(paymentMethodElement);
        }
    }

    renderGlobalError(show: boolean = true) {
       const errorContainer = this.getHtmlElement('#df-global-error-container');

       if (show) {
        if (errorContainer){
            return;
        }

        const button = this.getHtmlElement('#df_buybtn');
        if (button && button.parentElement) {
           button.parentElement.insertBefore(this.renderGlobalErrorField(), button);
        }
        return;
       }

       if (errorContainer) {
        errorContainer.remove();
       }
    }

    renderGlobalErrorField(): Node{
        const errorElement = document.createElement('div');
        errorElement.id = 'df-global-error-container';
        errorElement.innerHTML = `<p>Please complete all required fields.</p>`;
        return errorElement;
    }

    renderPayPalButton() {
        let paypalFormBlock = this.getHtmlElement('#paypal-form-block');
        if (paypalFormBlock) {
            const payPalPlace = this.getHtmlElement('#df-paypal-form-block');
            payPalPlace.appendChild(paypalFormBlock);
            paypalFormBlock = null as any;
        }
    }

    renderCopyright(container: HTMLElement) {
        const copyright = document.createElement('div');
        copyright.innerHTML = `<div id='dfLoader'></div>
            <div class='copyright'>
               <a href='https://www.depositfix.com/?ref=form'>${Translations.COPYRIGHT}</a>
            </div>`;
        container.appendChild(copyright);
    }

    renderTestModeBanner() {
        const testModeBanner = `
                <a class='test-mode-label' target='_blank' href='${HelpUrls.TEST_MODE}'>${Translations.TEST_MODE}</a>
            `;

        const copyright = this.getHtmlElement('#df-card-container .copyright');

        if (copyright && copyright.parentNode) {
            const banner = document.createElement('div');
            banner.innerHTML = testModeBanner;
            banner.setAttribute('id', 'df-test-mode');
            copyright.parentNode.insertBefore(banner, copyright);
        }
    }

    renderWidgetContainer() {
        this.removeElement('df-card-container');
        const iframeContainer = document.createElement('iframe');
        iframeContainer.id = 'df-iframe';



        const container = document.createElement('div');
        container.setAttribute('id', 'df-card-container');
        container.classList.add('df-main');


        const html = '<div id="df-card-container" class="df-main"></div>';


        //iframeContainer.append(container);
        //iframeContainer.contentWindow?.document.body.append(container);



        // const iframe = document.createElement('iframe');
        // iframe.src = 'data:text/html;charset=utf-8,' + encodeURI(html);
        // document.body.appendChild(iframe);
        // console.log('iframe.contentWindow =', iframe.contentWindow);


        const script = document.getElementById('df-script');
        if (script && script.parentNode) {
            script.parentNode.insertBefore(container, script.nextSibling);
        } else {
            document.body.append(container);
        }

        iframeContainer.contentWindow?.document.open();
        iframeContainer.contentWindow?.document.write(html);
        iframeContainer.contentWindow?.document.close();

    }

    renderCoverFees(coverFeesChangeCallback?: any) {
        const coverFeesFragment = document.createDocumentFragment();
        const coverFeesContainer = document.createElement('div');
        coverFeesContainer.setAttribute('id', 'coverFeesContainer');
        coverFeesContainer.innerHTML +=
            `<div style="margin-top: 15px">
                <label class="checkbox-inline">
                    <input type='checkbox' id='coverFees' class='df-checkbox' />
                    <span class='df-f-label'>${Translations.COVER_PROCESSING_FEES}</span>
                </label>
            </div>`;
        coverFeesFragment.appendChild(coverFeesContainer);

        const totalAmountContainer = this.getHtmlElement('#df-total-amount-container');
        if (totalAmountContainer) {
            totalAmountContainer.insertBefore(coverFeesFragment, totalAmountContainer.firstChild);
        }

        const coverFeesElement = this.getCoverFeesElement();
        if (coverFeesElement) {
            coverFeesElement.onchange = (event: any) => {
                coverFeesChangeCallback();
            };
        }
    }

    removeCoverFees() {
        const coverFeesContainer = this.getHtmlElement('#coverFeesContainer');
        if (coverFeesContainer) {
            coverFeesContainer.remove();
        }
    }

    getCoverFeesElement() {
        return document.getElementById('coverFees');
    }

    addWidgetFormTitle(title: string) {
        const titleNode = document.createElement('div');
        titleNode.className = 'df-title';
        titleNode.textContent = title;
        const parentNode = this.getDFContainer();

        if (parentNode) {
            parentNode.insertBefore(titleNode, parentNode.firstChild);
        }
    }

    hidePayNowButton() {
        const button = this.getHtmlElement('#df_buybtn');
        if (button) {
            button.style.display = 'none';
        }
    }

    setChangedAmount(subtotal: Subtotal, currency: string, totalAmount: string, forms: Form[]) {
        const totalField = this.getHtmlElement('#df-final-amount');
        if (!totalField) {
            return;
        }
        const totalAmountText = `${this.formatMoney(totalAmount, currency)}`;
        totalField.innerText = totalAmountText;
        const totalFieldFull = this.getHtmlElement('#df-subtotals');

        this.cleanSubtotal();

        const isMultiProductForm = this.isMultiProductForm(forms);

        forms.forEach(form => {
            switch (form.type) {

                case FormTypes.AdaptivePrices:
                    const adaptiveType = form as AdaptivePricesForm;
                    if (adaptiveType.quantity > 1) {
                        this.setQuantity(
                            adaptiveType.quantity,
                            adaptiveType.currentProduct.amount,
                            adaptiveType.currentProduct.name,
                            currency
                        );
                    }
                break;

                case FormTypes.AdaptiveSubscriptionPrices:
                    const adaptiveSubType = form as AdaptiveSubscriptionPricesForm;
                    if (adaptiveSubType.quantity > 1) {
                        this.setSubscriptionAmount(
                            adaptiveSubType.currentSubscription.name,
                            adaptiveSubType.currentSubscription.amount,
                            currency,
                            adaptiveSubType.currentSubscription.interval,
                            adaptiveSubType.currentSubscription.maxCharges,
                            adaptiveSubType.quantity
                        );
                    }
                break;

                case FormTypes.Product:
                    const prodType = form as ProductForm;
                    if (isMultiProductForm || prodType.quantity > 1) {
                        this.setQuantity(
                            prodType.quantity,
                            prodType.currentProduct.amount,
                            prodType.currentProduct.name,
                            currency
                        );
                    }
                    break;

                case FormTypes.Subscription:
                    const subtype = form as SubscriptionForm;
                    if (isMultiProductForm || subtype.quantity > 1) {
                        this.setSubscriptionAmount(
                            subtype.currentSubscription.name,
                            subtype.currentSubscription.amount,
                            currency,
                            subtype.currentSubscription.interval,
                            subtype.currentSubscription.maxCharges,
                            subtype.quantity
                        );
                    }
                    break;

                case FormTypes.Addon:
                    const addonType = form as AddonForm;
                    addonType.getSelectedProducts().forEach(addon => {
                        if (isMultiProductForm || addon.quantity > 1) {
                            this.setAddonQuantity(addon.quantity, addon.amount, addon.name, currency);
                        }
                    });
                    break;

                default:
                    break;
            }

        });

        if(subtotal.quantity && subtotal.quantity > 1){
        }

        if (subtotal.singleAmount && subtotal.subscriptionAmount) {
            // this.setSingleAmount(this.formatMoney(subtotal.singleAmount.toString(), currency));
            // this.setSubscriptionAmount(this.formatMoney(subtotal.subscriptionAmount.toString(), currency));
        }

        if (subtotal.singleAmount && subtotal.tax) {
            // this.setSingleAmount(this.formatMoney(subtotal.singleAmount.toString(), currency));
        }

        if (subtotal.subscriptionAmount && subtotal.tax) {
            // this.setSubscriptionAmount(this.formatMoney(subtotal.subscriptionAmount.toString(), currency));
        }

        if (subtotal.singleDiscount) {
            // this.setSingleAmount(this.formatMoney(subtotal.singleAmount.toString(), currency));
            this.setSingleDiscount(
                `-${this.formatMoney(subtotal.singleDiscount.toString(), currency)}`);
        }

        if (subtotal.subscriptionDiscount) {
            // this.setSubscriptionAmount(this.formatMoney(subtotal.subscriptionAmount.toString(), currency));
            this.setSubscriptionDiscount(
                `-${this.formatMoney(subtotal.subscriptionDiscount.toString(), currency)}`);
        }

        if (subtotal.tax) {
            this.setTax(this.formatMoney(subtotal.tax.toString(), currency), subtotal.taxRate || 0);
        }

        if (subtotal.messages) {
            subtotal.messages.forEach((message: string) => {
                const field = document.createElement('div');
                field.className = 'df-subtotal df-subtotal-';
                field.innerText = message;
                totalFieldFull.appendChild(field);
            });
        }
    }

    isMultiProductForm(forms: Form[]): boolean {
        const productTypes: string[] = [];

        forms.forEach(form => {
            switch (form.type) {
                case FormTypes.AdaptivePrices:
                    const adaptiveType = form as AdaptivePricesForm;
                    if (productTypes.indexOf(adaptiveType.type) === -1) {
                        productTypes.push(adaptiveType.type);
                    }
                    break;
                case FormTypes.AdaptiveSubscriptionPrices:
                    const adaptiveSubType = form as AdaptiveSubscriptionPricesForm;
                    if (productTypes.indexOf(adaptiveSubType.type) === -1) {
                        productTypes.push(adaptiveSubType.type);
                    }
                    break;
                case FormTypes.Product:
                    const prodType = form as ProductForm;
                    if (productTypes.indexOf(prodType.type) === -1) {
                        productTypes.push(prodType.type);
                    }
                    break;
                case FormTypes.Subscription:
                    const subtype = form as SubscriptionForm;
                    if (productTypes.indexOf(subtype.type) === -1) {
                        productTypes.push(subtype.type);
                    }
                    break;
                case FormTypes.Addon:
                    const addonType = form as AddonForm;
                    if (productTypes.indexOf(addonType.type) === -1) {
                        productTypes.push(addonType.type);
                    }
                    break;
                default:
                    break;
            }
        });
        return productTypes.length > 1;
    }

    setSubscriptionInterval(interval: string | null, maxCharges?: number | null) {
        const subscriptionIntervalElement = this.getHtmlElement('#df-subscription-interval');
        if (!subscriptionIntervalElement) {
            return;
        }

        this.clearSubtotalInterval();
        if (!interval || interval === DonationFrequencyType.ONE_TIME) {
            subscriptionIntervalElement.innerText = '';
        } else {
            let subscriptionIntervalText = `/${interval}`;
            if (maxCharges !== null && Number(maxCharges) && maxCharges !== undefined) {
                subscriptionIntervalText += ` X ${maxCharges} ${Translations.TIMES}`;
            }
            subscriptionIntervalElement.innerText = subscriptionIntervalText;
        }
    }

    setSubscriptionSubtotalInterval = (interval: string | null, maxCharges?: number | null) => {
        if (!interval) {
            return;
        }

        this.clearTotalInterval();
        let subscriptionSubtotalIntervalText = ``;
        if (maxCharges !== null && maxCharges !== undefined) {
            subscriptionSubtotalIntervalText += ` X ${maxCharges} ${Translations.TIMES}`;
        }
        const subscriptionSubtotalIntervalElement = this.getHtmlElement('.df-subtotal-subscription .sub-charges');
        subscriptionSubtotalIntervalElement.innerText = ` ${subscriptionSubtotalIntervalText}`;
    }

    clearSubtotalInterval() {
        const subscriptionSubtotalIntervalElement = this.getHtmlElement('.df-subtotal-subscription .sub-charges');
        if (subscriptionSubtotalIntervalElement) {
            subscriptionSubtotalIntervalElement.innerText = '';
        }
    }

    clearTotalInterval() {
        const subscriptionIntervalElement = this.getHtmlElement('#df-subscription-interval');
        if (subscriptionIntervalElement) {
            subscriptionIntervalElement.innerText = '';
        }
    }

    renderThankYouMessage(message: string) {
        this.getDFContainer().innerHTML = message;
    }

    clearContainer(){
        this.getDFContainer().innerHTML = '';
    }

    showPayButton() {
        const button = this.getHtmlElement('#df_buybtn');
        if (button) {
            button.style.display = 'inline-block';
        }
    }

    getCurrentURL() {
        if (document.location && document.location.href) {
            return document.location.href;
        } else {
            return '';
        }
    }

    getContext() {
        const input = this.getFromHSFrame('input[name =hs_context]');
        if (input) {
            const val = input.getAttribute('value');
            if (val !== null) {
                return JSON.parse(val);
            }
        }
    }

    applyCss(hsFormElement: HTMLElement) {

        if (hsFormElement) {

            const classList = Array.from(hsFormElement.classList);
            const uniqueClassName = classList.find(x => x.includes(hsFormElement.dataset.formId + '_'));

            if (!uniqueClassName) {
                return;
            }


            if (this.getHSFrame() !== document) {
                const fonts = Array.from(this.getHSFrame().querySelectorAll('link[rel=stylesheet]'));

                if (fonts) {
                    fonts.forEach(font => {
                        if (this.cacheService.checkIfCSSLoaded(font.getAttribute('href'))) {
                            return;
                        }
                        this.cacheService.addCSSToCache(font.getAttribute('href') as string);

                        const fontCopy = font.cloneNode(true);
                        document.getElementsByTagName('head')[0].appendChild(fontCopy);
                    });
                }
            }

            const styleElement = this.getFromHSFrame(
                uniqueClassName.replace('hs-form-', '#hs-form-style'));

            if (styleElement) {
                const styleCopy = styleElement.cloneNode(true);
                document.getElementsByTagName('head')[0].appendChild(styleCopy);
            }

            const forms = document.querySelectorAll('.hs-form');

            if (forms) {
                Array.prototype.forEach.call(forms, (form: HTMLElement) => {
                    form.classList.add(uniqueClassName);
                });
            }

            const id = hsFormElement.getAttribute('data-form-id');
            const mainForms = document.querySelectorAll('#df-card-container > form');
            if (mainForms && id) {
                mainForms.forEach((item) => {
                    if (!item.classList.contains(id)) {
                        item.classList.add(id);
                    }
                });
            }
        }
    }

    loadJS(src: string) {
        if (this.cacheService.checkIfJsLoaded(src)) {
            return;
        }

        this.cacheService.addJsToCache(src);

        const script = document.createElement('script');
        script.setAttribute('src', src);
        script.async = true;
        document.getElementsByTagName('head')[0].appendChild(script);
    }



    cleanSubtotal() {
        // this.setSingleAmount('');
        // this.setSubscriptionAmount('');
        this.setSubscriptionDiscount('');
        this.setSingleDiscount('');

        const subContainer = document.querySelector('.df-subtotal-subscription') as HTMLElement;
        if(subContainer){
          this.hide(subContainer);
        }

        document.querySelectorAll('.df-subtotal').forEach(e => this.hide(e));
        const addonsContainer = document.getElementById('df-addon-container');
        if(addonsContainer){
            addonsContainer.innerHTML = '';
        }
    }

    setSubscriptionAmount(productName: string,  baseAmount: number, currency: string, frequency?: string, maxCharges?: number , quantity?: number) {
        this.show(this.getHtmlElement('.df-subtotal-subscription'));
        this.setVal('.df-subtotal-subscription .sub-name', productName);
        this.setVal('.df-subtotal-subscription .base-price', this.formatMoney(baseAmount.toString(), currency));

        this.setVal('.df-subtotal-subscription .sub-quantity', quantity && quantity > 1 ? ` X ${quantity}` : '');
        this.setVal('.df-subtotal-subscription .sub-frequency', frequency ? `/${frequency}` : '');
    }

    setSubscriptionDiscount(amount: string) {
        this.show(this.getHtmlElement('.df-subtotal-discount'));
        this.setVal('.df-subtotal-discount .discount', amount);
    }

    setSingleAmount(amount: string) {
        // this.show(this.getHtmlElement('.df-subtotal-single'));
        // this.setVal('.df-subtotal-single .amount', amount);
    }

    setSingleDiscount(amount: string) {
        this.show(this.getHtmlElement('.df-subtotal-discount'));
        this.setVal('.df-subtotal-discount .discount', amount);
    }

    setTax(amount: string, rate: number) {
        this.show(this.getHtmlElement('.df-subtotal-tax'));
        this.setVal('.df-subtotal-tax .amount', amount);
        this.setVal('.df-subtotal-tax .tax-rate', rate.toString());
    }

    setQuantity(quantity: number, baseAmount: number, productName: string, currency: string){
        this.show(this.getHtmlElement('.df-subtotal-quantity'));
        this.setVal('.df-subtotal-quantity .quantity-amount', `${quantity && quantity > 1 ? ' X ' : ''} ${quantity && quantity > 1 ? quantity : ''}`);
        this.setVal('.df-subtotal-quantity .prod-name', productName);
        this.setVal('.df-subtotal-quantity .base-price', this.formatMoney(baseAmount.toString(), currency));
        // this.setVal('.df-subtotal-quantity .total-price', this.formatMoney((baseAmount * quantity).toString(), currency));
    }

    setAddonQuantity(quantity: number, baseAmount: number, productName: string, currency: string) {
        this.show(this.getHtmlElement('.df-subtotal-addons'));

        const container = document.getElementById('df-addon-container');

        const elementId = this.getValidElementId(productName);
        const el = container && container.querySelector('#add-' + elementId);

        if(el){
            el.innerHTML =  `+ <div class='df-f-label-container'><span class='prod-name df-f-label'>${productName}</span>
            X <span class='quantity-amount df-f-label'>${quantity}</span></div>
            <div class='df-f-value-container'><span class='base-price df-f-value'>${this.formatMoney(baseAmount.toString(), currency)}</span></div>
            `;
            return;
        }

        const createEl = document.createElement('div');
        createEl.style.display = 'block';
        createEl.id = 'add-' + this.getValidElementId(productName);
        createEl.innerHTML = `<div class='df-f-label-container'><span class='prod-name df-f-label'>${productName}</span>
        ${quantity > 1 ? 'X' : ''} <span class='quantity-amount df-f-label'>${quantity > 1 ? quantity : ''}</span></div>
        <div class='df-f-value-container'><span class='base-price df-f-value'>${this.formatMoney(baseAmount.toString(), currency)}</span></div>
        `;

        container && container.appendChild(createEl);
    }

    getValidElementId(productName: string) {
        return productName.replace(/[^a-zA-Z0-9_]/g, '_');
    }

    renderStepButtons(stepSubject: BehaviorSubject<number>, maxStep: number, widget: any) {
        const container =  this.getDFContainer();

        const stepBack = document.createElement('button');
        stepBack.classList.add('df-f-step-btn', 'df-f-step-back-btn');
        stepBack.style.display = 'none';
        stepBack.innerText = Translations.STEP_BACK;

        stepBack.addEventListener('click', () => {
            widget.lastStepValue = stepSubject.value;
            widget.watchSteps(stepSubject.value - 1);
        });

        const stepForward = document.createElement('button');
        stepForward.classList.add('df-f-step-btn', 'df-f-step-forward-btn');
        stepForward.innerText = Translations.STEP_FORWARD;

        stepForward.addEventListener('click', () => {
            widget.lastStepValue = stepSubject.value;
            widget.watchSteps(stepSubject.value + 1);
        });

        const spanSpace = document.createElement('span');
        spanSpace.innerHTML = '&nbsp;';

        container.appendChild(stepBack);
        container.appendChild(spanSpace);
        container.appendChild(stepForward);

        stepSubject.subscribe(step => {
            stepBack.style.display = step === 1 ? 'none' : 'initial';
            stepForward.style.display = step === maxStep ? 'none' : 'initial';
        });
    }

}
